<template>
  <div class="pageContainer">
    <div class="topDiv backgroundCoverImageCenter">
      <h1>
        Contact Us
      </h1>
    </div>
    <div class="bottomDiv">
      <div class="container">
        <div>
          <h4 style="margin-bottom:0">Address:</h4>
          <p>Keas 69 Str.</p>
          <p>15234, Chalandri</p>
          <p>Athens,Greece</p>
        </div>
        <div>
            <h5>+30-2106019311 (landline)<br/>
                +30-6977664062 (mobile phone)<br/>
                +30-2106398905 (fax)
            </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact' /*,
  data () {
    return {}
  } */
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~scssDir/_breakpoints.scss";
@import "~scssDir/_variables.scss";
@import "~scssDir/_myAnimations.scss";
.topDiv {
  height: 60px;
  background-color: $color5;
  @include media-md{
    height:30vh;
  }
  h1 {
    line-height: 20px;
    color: $color2;
    @include media-md{
      line-height: unset;
    }
  }
}
.bottomDiv {
  height: 70vh;
  background-color: $color4;
  h4{
    color:$color1;
  }
  p{
    padding:1px;
    font-size:16px;
    line-height:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue